import { Flow } from "../types/IFlow";
import {
  SingleMedicalStepDefaultNavigatorConfiguration,
  SingleMedicalStepPreQualifiedPatientNavigatorConfiguration
} from "./NavigatorConfigurations";
import {
  experimentalScreeningStepConfigurations,
  noConfirmationCenterSelectableBookingStepConfigurations
} from "./StepConfigurations";

const singleMedicalStepNewPatientFlowName = "SingleMedicalStepNewPatientFlow";

/** The treatment flow where a new patient experiences the single-page medical presentation. */
class SingleMedicalStepNewPatientFlow extends Flow {
  static readonly flowName = singleMedicalStepNewPatientFlowName;
  readonly name = singleMedicalStepNewPatientFlowName;
  readonly steps = {
    ...experimentalScreeningStepConfigurations,
    ...noConfirmationCenterSelectableBookingStepConfigurations
  };
  readonly navigatorItems = SingleMedicalStepDefaultNavigatorConfiguration;
  isDisqualificationPossible() {
    return true;
  }
}

/** The treatment flow for pre-qualified new patients (scheduling-only path). */
export class PreQualifiedSingleMedicalStepNewPatientFlow extends Flow {
  readonly name = singleMedicalStepNewPatientFlowName;
  readonly steps = { ...noConfirmationCenterSelectableBookingStepConfigurations };
  readonly navigatorItems = SingleMedicalStepPreQualifiedPatientNavigatorConfiguration;
  isDisqualificationPossible() {
    return false;
  }
}

export default SingleMedicalStepNewPatientFlow;
